import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";

function DocumentRenameModal({ isOpen, documentName, onConfirm, onClose }) {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      aria-labelledby="contained-modal-vcenter"
      centered
      backdrop={false}
      style={{
        zIndex: 1000000,
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(0, 0, 255, 0.1)",
      }}
    >
      <Modal.Header
        style={{
          borderBottom: "0px",
        }}
        className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
      >
        <Modal.Title
          className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          id="modal_title"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          Rename Confirmation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="document-modal-body" style={{ margin: "1rem" }}>
        <p>
          Do you want to rename this document to <b>{documentName}</b>?
        </p>
      </Modal.Body>
      <div className="d-flex align-items-center justify-content-between py-0 px-1 p-b-5">
        <Button variant="secondary" onClick={onClose} className="btn py-0 height-25">
          Close
        </Button>
        <Button variant="success" onClick={onConfirm} className="btn py-0 height-25">
          Confirm
        </Button>
      </div>
    </Modal>
  );
}

DocumentRenameModal.propTypes = {
  isOpen: PropTypes.bool,
  documentName: PropTypes.string,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
};

DocumentRenameModal.defaultProps = {
  isOpen: false,
  documentName: "",
  onConfirm: () => {},
  onClose: () => {},
};

export default DocumentRenameModal;
